/**
 * React Query key for the Page query. A page with an active experiment holds only its bucket's slot (the other is
 * pruned in serverSideProps), so its data is cached per bucket. A visitor who consents mid-visit moves from no
 * bucket (the original) to a bucket, so a client-side return to the same page can arrive in a different state:
 * with its own key, that response is a new query and hydrates during render, instead of the stale entry rendering
 * an empty slot until HydrationBoundary's post-commit effect catches up. Pages without an experiment, and
 * visitors without a bucket, keep the plain key.
 * Shared by serverSideProps and the page component — they must agree or the dehydrated data isn't found.
 */
import type { Bucket } from './bucket';
import { usePageQuery } from '@/utils/dato/generated';

export const pageQueryKey = (pageSlug: string, bucket: Bucket | null) =>
  bucket ? [...usePageQuery.getKey({ pageSlug }), { bucket }] : usePageQuery.getKey({ pageSlug });
